import { Table, Button } from 'antd';
import { useSelector } from "react-redux";
import { StringUtils } from '../../utils/strings';
import { DownloadOutlined } from '@ant-design/icons';
import { exportToXLSX } from '../../services/exportReport';

const cleanupReport = (rawData, includeDate = true) => {
  return rawData.map((record, index) => {
    const {revenue, impressions, adsRequests, clicks, viewableImpressions, ctr, fillRate, viewability, date, cpm, ...rest} = record;
    const result = {
      key: index,
      ...rest,
      impressions,
      revenue: revenue.toFixed(2),
      cpm
    };
    if (includeDate) {
      result.date = date;
    }
    return result;
  });
}

const buildColumns = (r_dimension_1, r_dimension_2, r_dimension_3, splitByDay, isDeal) => {
  const finalArray = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => index + 1, 
    }
  ]
  if(splitByDay) { 
    finalArray.push({
      title: "Date",
      dataIndex: "date",
      defaultSortOrder: 'ascend',
    })
  }
  if(r_dimension_1) { 
    finalArray.push({
      title: StringUtils.capitalizeFirstLetter(r_dimension_1) === 'Provider' ? 'Platform' : StringUtils.capitalizeFirstLetter(r_dimension_1),
      dataIndex: r_dimension_1,
      sorter: (a, b) => a[r_dimension_1] - b[r_dimension_1],
      render: (r_dimension_1) => r_dimension_1 || 'n/a'
    })
  }
  if(r_dimension_2) { 
    finalArray.push({
      title: StringUtils.capitalizeFirstLetter(r_dimension_2) === 'Provider' ? 'Platform' : StringUtils.capitalizeFirstLetter(r_dimension_2),
      dataIndex: r_dimension_2,
      sorter: (a, b) => a[r_dimension_2] - b[r_dimension_2],
      render: (r_dimension_2) => r_dimension_2 || 'n/a'
    })
  }
  if(r_dimension_3) { 
    finalArray.push({
      title: StringUtils.capitalizeFirstLetter(r_dimension_3) === 'Provider' ? 'Platform' : StringUtils.capitalizeFirstLetter(r_dimension_3),
      dataIndex: r_dimension_3,
      sorter: (a, b) => a[r_dimension_3] - b[r_dimension_3],
      render: (r_dimension_3) => r_dimension_3 || 'n/a'
    })
  }
  if(isDeal) { 
    finalArray.push({
      title: "Deal Name",
      dataIndex: 'dealName',
      sorter: (a, b) => a.dealName - b.dealName
    })
  }
  finalArray.push(
    {
      title: 'Revenue (€)',
      dataIndex: 'revenue',
      sorter: (a, b) => a.revenue - b.revenue,
      render: (revenue) => StringUtils.getUSnumbersFormating(revenue)
    },
    {
      title: 'Impressions',
      dataIndex: 'impressions',
      sorter: (a, b) => a.impressions - b.impressions,
      render: (impressions) => StringUtils.getUSnumbersFormating(impressions)
    },
    {
      title: 'CPM (€)',
      dataIndex: 'cpm',
      sorter: (a, b) => a.cpm - b.cpm,
    }
  )
  return finalArray
} ;

const ReportsTable = ({fullData}) => {

  // Extrating report-related state
  const reportReducer = useSelector((state) => state.reportReducer);
  const {r_dimension_1, r_dimension_2, r_dimension_3, splitByDay, isDeal} = reportReducer;

  // Export data to Excel
  const cleanData = cleanupReport(fullData, splitByDay);
  const handleExportData = () => exportToXLSX(cleanData);  

  const columns = buildColumns(r_dimension_1, r_dimension_2, r_dimension_3, splitByDay, isDeal);

  return (<>
      <Button 
        className="std-button" 
        size="large"
        onClick={handleExportData}
        style={{alignSelf: "flex-end"}}
      >
        <DownloadOutlined /> Export
      </Button>
      <Table 
        className="summary-table" 
        columns={columns}
        dataSource={cleanData} 
        scroll={{ x: '70vw' }}
      />
  </>);
};
export default ReportsTable;